import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LanguageSelector from 'nallian-shared-ui/lib/layout/LanguageSelector';
import { Flex } from 'nallian-shared-ui/lib/components';
import { Text, ErrorIcon } from 'nallian-shared-ui/lib/layout/styles';

const InvitationError = ({ expired, retracted }) => {
  const { t } = useTranslation();

  return (
    <>
      <LanguageSelector isPublic isFixed isOnWhiteBackground />
      <Flex direction="column" alignItems="center">
        <ErrorIcon name="close" color="white" size="large" />
        <Flex margin="1rem 0 0">
          <Text>
            <span>{t('invalidInvitation1')}&nbsp;</span>
            <span>
              {t(
                expired
                  ? 'invitationIsExpired'
                  : retracted
                  ? 'inviationNotValidAnymore'
                  : 'invalidInvitation2'
              )}
            </span>
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

InvitationError.propTypes = {
  expired: PropTypes.bool,
  retracted: PropTypes.bool,
};

InvitationError.defaultProps = {
  expired: false,
  retracted: false,
};

export default InvitationError;
